import { CarouselApi } from '@/components/ui/carousel'
import { useEffect } from 'react'

export type UseScrollToItemProps = {
  api?: CarouselApi
  itemIndex: number
  forceScroll?: boolean
  onScroll?: () => void
}

/**
 * Try to scroll to the selected item when the carousel is initialized.
 */
export default function useScrollToCarouselSelectedItem({
  api,
  itemIndex,
  forceScroll,
  onScroll = () => {},
}: UseScrollToItemProps) {
  useEffect(() => {
    if (!api) {
      return
    }

    const scrollToSelectedItem = () => {
      if (itemIndex === -1) {
        return
      }

      setTimeout(() => {
        const shouldScroll = forceScroll || api.slidesNotInView().includes(itemIndex)
        if (shouldScroll) {
          api.scrollTo(itemIndex)
        }
        onScroll()
      }, 100)
    }

    api.on('reInit', scrollToSelectedItem)

    scrollToSelectedItem()

    return () => {
      api.off('reInit', scrollToSelectedItem)
    }
  }, [api, forceScroll, itemIndex, onScroll])
}
